function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m12.75 13.33h-10.5c-.97 0-1.75-.81-1.75-1.82v-1.87c0-1 .78-1.82 1.75-1.82h10.5c.97 0 1.75.81 1.75 1.82v1.87c0 1-.78 1.82-1.75 1.82zm0-7.32h-10.5c-.97 0-1.75-.81-1.75-1.82v-1.87c0-1 .78-1.82 1.75-1.82h10.5c.97 0 1.75.81 1.75 1.82v1.87c0 1-.78 1.82-1.75 1.82zm0-3.69h-10.5v1.87h10.5z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 13.83"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/goals-outlined.66852100.svg";
export { SvgComponent as ReactComponent };